import { render, staticRenderFns } from "./RedirectDownload.vue?vue&type=template&id=34397738&"
import script from "./RedirectDownload.vue?vue&type=script&lang=js&"
export * from "./RedirectDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports